import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class UserInforApi extends SystemBaseApi {
  public get ControllerName(): any {
    return 'userinfor'
  }


  /**
   * 查询用户列表
   * @returns 
   */
  public getUserList(params) {
    return this.send(params, "getUserList", Methods.GET)
  }

  /**
   * 查询用户列表(分页)
   * @returns
   */
  public getUserListPage(params) {
    return this.send(params, "getEntitiesPage", Methods.GET)
  }

  /**
   * 监理信息化查询用户列表(分页)
   * @returns
   */
     public getZjUserInfoList(params) {
      return this.send(params, "getZjUserInfoList", Methods.GET)
    }
  /**
   * 保存或修改用户信息
   * @param param 
   * @returns 
   */
  public saveUserInfo(param) {
    return this.send(param, "update", Methods.POST)
  }
  /**
   * 删除用户
   * @param id 
   */
  public deleteUser(id) {
    return this.send({}, "delete?ids=" + id, Methods.POST)
  }
  /**
   * 批量导入用户
   * @param param 
   */
  public importUserList(param) {
    return this.send(param, "importUserList", Methods.POST)
  }

  /**
   * 项目id查询用户列表
   * @param projectId 
   */
  public getUserListByProjectId(projectDataId, current, size, userName, userPhone, cidNo) {
    return this.send({ projectDataId: projectDataId, current: current, size: size, userName: userName, userPhone: userPhone, cidNo: cidNo }, "getUserListByProjectId", Methods.GET)
  }

  /**
   * 子项目管理员保存用户信息
   * @param param 
   */
  public saveUserRelation(param) {
    return this.send(param, "saveUserRelation", Methods.POST)
  }

  /**
   * 子项目管理员删除用户
   * @param id 
   */
  public subDeleteUser(id) {
    return this.send({}, "subDeleteUser?id=" + id, Methods.POST)
  }
  /**
   * 已删除人员恢复
   * @param id 
   * @returns 
   */
  public recoverUser(id) {
    return this.send({ id: id }, "recoverUser", Methods.GET)

  }
  /**
   * 查询所有人员列表
   * @returns 
   */
  public getAllUserList() {
    return this.send({}, "getAllUserList", Methods.GET)
  }
  /**
   * 人员预分派项目id查询用户列表
   * @param projectDataId 
   * @param userName 
   * @param userPhone 
   * @param cidNo 
   * @returns 
   */
  public getPersonList(projectDataId, current, size, userName, userPhone, cidNo, institutionId) {
    return this.send({ projectDataId: projectDataId, current: current, size: size, userName: userName, userPhone: userPhone, cidNo: cidNo, institutionId: institutionId }, "getPersonList", Methods.GET)
  }

  //修改密码
  public updatePassword(param) {
    return this.send(param, "updatePassword", Methods.POST)
  }

  //重置密码
  public resetPassword(param) {
    return this.send(param, "resetPassword", Methods.GET)
  }

  /**
   * 用户名查询用户
   * @param userName 
   * @returns 
   */
  public getUserByUserName(userName) {
    return this.send({ userName: userName }, "getUserByUserName", Methods.GET)
  }

  /**
   * 用户模糊搜索
   * @param userName 
   * @returns 
   */
  public getUserBySearch(userName) {
    return this.send({ userName: userName }, "getUserBySearch", Methods.GET)
  }

  /**
   * 修改用户信息
   * @param param
   */
  public updateUserInfo(param) {
    return this.send(param, "updateUserInfo", Methods.POST)
  }
  /**
   * feign调用获取用户信息及对应的机构信息
   * @param ids 
   * @param subProjectId 
   */
  public getBatchList(ids, subProjectId) {
    return this.send({ subProjectId: subProjectId }, 'getBatchList?ids=' + ids, Methods.GET)
  }
  /**
 * 获取用户新机构
 * @param ids 
 * @param subProjectId 
 */
  public getuserBatchList(ids, subProjectId) {
    return this.send({ subProjectId: subProjectId }, 'getuserBatchList?ids=' + ids, Methods.GET)
  }

  public getUserListByUserName(userNames) {
    return this.send({ userNames: userNames }, 'getUserListByUserName', Methods.GET)
  }

  /**
   * 获取部门领导
   * @param ids
   * @param subProjectId
   */
  public getManagerByUserId(parms) {
    return this.send(parms, 'getManagerByUserId', Methods.GET)
  }

  /**
   * 获取部门领导
   */
   public getLlManagerByUserId(parms) {
    return this.send(parms, 'getLlManagerByUserId', Methods.GET)
  }

  public getUserIds(userName) {
    return this.send({ userName: userName }, 'getUserIds', Methods.GET)
  }


  // public getUserinfoList(param) {
  //   return this.send({ current: param.current, size: param.size, projectId: param.projectId, userName: param.userName, delFlag: param.delFlag }, 'getUserListPage', Methods.GET)
  // }

  public getUserByUserId(ids){
    return this.send({ ids: ids }, 'getUserByUserId', Methods.GET)
  }

  /**
   * 移除缓存
   * @param param
   */
  public removeUserRedis(param) {
    return this.send(param, "removeUserRedis", Methods.POST)
  }

  public getSTJLApproveUser(institutionId){
    return this.send({ institutionId: institutionId }, 'getSTJLApproveUser', Methods.GET)
  }
  public getUserInfoList(projectId){
    return this.send({ projectId: projectId }, 'getUserInfoList', Methods.GET)
  }
}